export const NOT_FOUND =
  'We are sorry, but the record you are looking for does not exist.';
